<div class="tab-content">
  <div class="page-title" translate>ADDITIONAL_FEATURES</div>
  <div class="tree-grid">
    <tree-root
      *ngIf="features && features.length > 0"
      [nodes]="features"
      [focused]="false"
      [options]="optionsTreeNode"
      [hideNode]="hideNode"
      #tree
      class="tree-view"
    >
      <ng-template #treeNodeTemplate let-node="node" let-index="index">
        <span>
          <p-checkbox [binary]="true" [indeterminate]="node.data.checked == null"
            (onChange)="check(node, { value: $event.checked })"
            [disabled]="
              (node?.data?.id === 180 && !node?.data?.access) ||
              (roleId === 2 && portalFeatures === null) ||
              (roleId !== 1 && !node?.data?.access) ||
              (roleId === 1 && isPortalExists) ||
              (filterFeaturesKey && filterFeaturesKey.indexOf(node.id) > -1)
            "
            [(ngModel)]="node.data.checked"
           ></p-checkbox>
        </span>
        <span>
          <span
            class="treeNode"
            title="{{
              nodeLabelKey(node) ? (nodeLabelKey(node) | translate) : ''
            }}"
            translate
          >
            {{ nodeLabelKey(node) || "Unknown Feature" }}
          </span>
        </span>
      </ng-template>
    </tree-root>
  </div>
</div>
